// components/CustomTooltip.js
import React from "react";

const CustomTooltip = ({ active, payload, label, isDarkMode }) => {
  if (!active || !payload || payload.length === 0) return null;

  const value = payload[0].value;

  return (
    <div
      className={`rounded-lg px-3 py-2 shadow-lg border ${
        isDarkMode
          ? "bg-gray-800 border-gray-700 text-gray-100"
          : "bg-white border-gray-200 text-gray-900"
      }`}
      style={{ backdropFilter: "blur(4px)" }}
    >
      <p className="font-medium">{label}</p>
      <p>
        {value.toLocaleString("th-TH", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}{" "}
        บาท
      </p>
    </div>
  );
};

export default CustomTooltip;
